import {
    createSlice,
    PayloadAction,
} from "@reduxjs/toolkit";

export interface SchemeData {
    _id?: string;
    schemeId?: string;
    name: string;

    grossTenure: number;
    advancedEMI: number;

    subventionCost: number;

    interestBased: boolean;
    annualInterest: number;

    processingRate: number;
    GST: number;

    min: number;
    calOnRootAmt: boolean;

    for: string[];
    lender: string[];
    category: string[];

    isActive: boolean;

    merchantPF: number;
}

export interface SchemeCalculation {
    loanAmount: number;
    grossTenure: number;
    advancedEMI: number;
    NoOfNetEmis: number;
    netLoanAmount: number;
    customerROI: number;
    totalProcessingFee: number;
    monthlyEMI: number;
    totalInterest: number;
    totalDownPayment: number;
    advancedEmiPayment: number;
    DBDToDealer: number;
    DealerGets: number;
    netDisbursement: number;
    name: string;
}

export interface CalculatedScheme {
    amount: number;
    scheme: SchemeData;
    calculations: SchemeCalculation;
}

interface SchemeState {
    schemes: CalculatedScheme[];
    selectedScheme: CalculatedScheme | null;
    amount: number | null;
}

const initialState: SchemeState = {
    schemes: [],
    selectedScheme: null,
    amount: null,
};

const schemeSlice = createSlice({
    name: "scheme",

    initialState,

    reducers: {

        /*
         * Store all available schemes.
         */
        setSchemes: (
            state,
            action: PayloadAction<{
                amount: number;
                schemes: CalculatedScheme[];
            }>
        ) => {
            state.amount =
                action.payload.amount;

            state.schemes =
                action.payload.schemes;
        },


          
                /*
         * Store the selected scheme.
         *
         * This is called after the user successfully
         * selects a scheme. `schemes` (the full list) is
         * left untouched, so navigating back to the scheme
         * picker still has every option available to
         * reselect from.
         */
        setSelectedScheme: (
            state,
            action: PayloadAction<CalculatedScheme>
        ) => {
            state.selectedScheme =
                action.payload;
        },


        /*
         * Clear all schemes.
         */
        clearSchemes: (state) => {
            state.schemes = [];
            state.selectedScheme = null;
            state.amount = null;
        },
    },
});

export const {
    setSchemes,
    setSelectedScheme,
    clearSchemes,
} = schemeSlice.actions;

export default schemeSlice.reducer;